import { Skeleton } from '@mui/material';
import { Typography } from '@mui/material';

import { TextTooltip } from 'modules/common/components/TextTooltip';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { networkUsageCardTranslation } from './translation';
import { useNetworkUsageCardStyles } from './useNetworkUsageCardStyles';

interface NetworkUsageCardProps {
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  title: string;
  tooltip?: string;
  value: string;
}

export const NetworkUsageCard = ({
  className,
  disabled = false,
  loading,
  title,
  tooltip,
  value,
}: NetworkUsageCardProps) => {
  const { classes, cx } = useNetworkUsageCardStyles({
    disabled,
    hasTooltip: Boolean(tooltip),
  });

  const { keys, t } = useTranslation(networkUsageCardTranslation);

  const content = disabled ? (
    <Typography className={classes.content} variant="body3">
      {t(keys.noDataAvailable)}
    </Typography>
  ) : (
    <Typography className={classes.content} variant="subtitle2">
      {value}
    </Typography>
  );

  return (
    <div className={cx(classes.root, className)}>
      <TextTooltip disableHoverListener={false} title={tooltip}>
        <Typography className={classes.title} variant="body4">
          {title}
        </Typography>
      </TextTooltip>
      {loading ? <Skeleton className={classes.skeleton} /> : content}
    </div>
  );
};
